import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatCurrency } from '@if/core/utils'
import { PersonalLoanCalculatorConstants } from '@src/types/Constants'

interface CalculatedRate {
  paymentForFrequency?: number
}

interface PaymentEstimateCardProps {
  isFetching: boolean
  calculatedRate?: CalculatedRate | null
}

export const PaymentEstimateCard = ({ isFetching, calculatedRate }: PaymentEstimateCardProps) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        p: 3,
        marginTop: 5,
        border: '2px solid',
        borderColor: 'primary.main',
        borderRadius: 2,
        backgroundColor: 'background.paper',
        boxShadow: 2,
        textAlign: 'center',
        position: 'sticky',
        top: PersonalLoanCalculatorConstants.STICKY_TOP_OFFSET,
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom color="primary">
        {t('calculator.monthlyPaymentEstimate')}
      </Typography>

      <Typography variant="h2" component="div">
        {isFetching
          ? t('calculator.calculating')
          : calculatedRate?.paymentForFrequency
            ? formatCurrency(calculatedRate.paymentForFrequency)
            : formatCurrency(0)}
      </Typography>

      <Typography variant="body1" sx={{ mt: 2 }}>
        {t('calculator.bestWayToKnow')}
      </Typography>
    </Box>
  )
}
